import axios from 'axios';
/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 21/03/18
 */
import { PAYMENT_METHODS } from './constant';

export function getAllPaymentMethods() {
  return axios.get(PAYMENT_METHODS);
}
